import { PaperProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InvoiceStatus, useAdminClaimQuery } from '../../../../api/gql';
import { InvoiceStatusInfoBox } from '../../../../components/InvoiceStatusInfoBox';

type Props = {
  claimId: string;
} & PaperProps;

export const ClaimStatusInfoBoxModule = ({ claimId, ...rest }: Props) => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useAdminClaimQuery({
    id: claimId,
  });
  return (
    <InvoiceStatusInfoBox
      status={data?.adminInvoice?.status ?? InvoiceStatus.Processing}
      isLoading={isLoading}
      errorMessage={isError ? (t('query.error.default') as string) : undefined}
      titleProps={{ variant: 'h2' }}
      {...rest}
    />
  );
};
